import { jsxs, jsx } from "react/jsx-runtime";
import { useInView } from "react-intersection-observer";
import styled, { css } from "styled-components";
import { token } from "./token.js";
function Head({
  stickyOffset,
  children,
  ...props
}) {
  const {
    ref,
    inView
  } = useInView({
    threshold: 1,
    initialInView: true
  });
  return /* @__PURE__ */ jsxs(StyledHeader, {
    $stickyOffset: stickyOffset,
    $isStuck: !inView,
    ...props,
    children: [typeof stickyOffset === "string" && /* @__PURE__ */ jsx("tr", {
      children: /* @__PURE__ */ jsx("th", {
        style: {
          padding: 0
        },
        children: /* @__PURE__ */ jsx(Trigger, {
          ref
        })
      })
    }), /* @__PURE__ */ jsx("tr", {
      children
    })]
  });
}
const StyledHeader = styled.thead.withConfig({
  displayName: "StyledHeader",
  componentId: "sc-7z0vuq-0"
})(["", ""], (props) => typeof props.$stickyOffset === "string" && css(["--table-head-sticky-offset:", ";position:sticky;top:var(--table-head-sticky-offset);z-index:1;background-color:", ";", ""], props.$stickyOffset === "0" ? "0px" : props.$stickyOffset, token.white, props.$isStuck && css(["box-shadow:0 3px 0 ", ",0 1px 0 ", ";"], token.gray50a, token.gray100a)));
const Trigger = styled.div.withConfig({
  displayName: "Trigger",
  componentId: "sc-7z0vuq-1"
})(["position:absolute;top:calc((var(--table-head-sticky-offset) + 1px) * -1);width:1px;height:1px;"]);
export {
  Head
};
//# sourceMappingURL=Head.js.map
